import { API, Endpoints } from '@brg/api';
import { useEffect, useState } from 'react';
import { useProfile } from '@brg/auth';
import { useTranslation } from 'react-i18next';

interface UseGetManyByListPaginatedParams {
    idsLongread: string[];
    limit?: number;
    offset?: number;
    page?: number;
    thematic?: string;
    lang?: string;
    sort?: string;
    styles?: string[];
    excludeStyles?: string[];
    disabled?: boolean;
}

export const useGetManyByListPaginated = ({
    idsLongread,
    limit = 0,
    offset = 0,
    page = 0,
    thematic,
    lang,
    sort = '',
    styles,
    excludeStyles,
    disabled = false,
}: UseGetManyByListPaginatedParams) => {
    const [resp, setResp] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const profile = useProfile();
    const { i18n } = useTranslation();
    const idUser = profile?.accountId || '';
    const currentLang = lang || i18n.language;

    useEffect(() => {
        if (disabled || !idsLongread || idsLongread.length === 0) {
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        setError(false);

        const request = API.request()
            .endpoint(Endpoints.longread)
            .url('api/post/GetManyByListPaginated')
            .get()
            .addQuery('idUser', idUser)
            .addQuery('idsLongread', idsLongread)
            .addQuery('limit', limit)
            .addQuery('offset', offset)
            .addQuery('page', page)
            .addQuery('lang', currentLang)
            .addQuery('sort', sort);

        if (thematic) {
            request.addQuery('thematic', thematic);
        }

        if (styles && styles.length > 0) {
            request.addQuery('styles', styles);
        }

        if (excludeStyles && excludeStyles.length > 0) {
            request.addQuery('excludeStyles', excludeStyles);
        }

        request
            .send()
            .then((r) => r.json())
            .then((r) => {
                setResp(Array.isArray(r.data) ? r.data : []);
                setIsLoading(false);
            })
            .catch((e) => {
                setError(true);
                setIsLoading(false);
            });
    }, [idsLongread, limit, offset, page]);

    return { data: resp, isLoading, error };
};

import { API, Endpoints } from '@brg/api';
import { useEffect, useState } from 'react';
import { useProfile } from '@brg/auth';
import { useTranslation } from 'react-i18next';

interface UseGetManyByListPaginatedParams {
    idsLongread: string[];
    limit?: number;
    offset?: number;
    page?: number;
    thematic?: string;
    lang?: string;
    sort?: string;
    styles?: string[];
    excludeStyles?: string[];
    disabled?: boolean;
}

export const useGetManyByListPaginated = ({
    idsLongread,
    limit = 0,
    offset = 0,
    page = 0,
    thematic,
    lang,
    sort = '',
    styles,
    excludeStyles,
    disabled = false,
}: UseGetManyByListPaginatedParams) => {
    const [resp, setResp] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const profile = useProfile();
    const { i18n } = useTranslation();
    const idUser = profile?.accountId || '';
    const currentLang = lang || i18n.language;

    useEffect(() => {
        if (disabled || !idsLongread || idsLongread.length === 0) {
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        setError(false);

        const request = API.request()
            .endpoint(Endpoints.longread)
            .url('api/post/GetManyByListPaginated')
            .get()
            .addQuery('idUser', idUser)
            .addQuery('idsLongread', idsLongread)
            .addQuery('limit', limit)
            .addQuery('offset', offset)
            .addQuery('page', page)
            .addQuery('lang', currentLang)
            .addQuery('sort', sort);

        if (thematic) {
            request.addQuery('thematic', thematic);
        }

        if (styles && styles.length > 0) {
            request.addQuery('styles', styles);
        }

        if (excludeStyles && excludeStyles.length > 0) {
            request.addQuery('excludeStyles', excludeStyles);
        }

        request
            .send()
            .then((r) => r.json())
            .then((r) => {
                setResp(Array.isArray(r.data) ? r.data : []);
                setIsLoading(false);
            })
            .catch((e) => {
                setError(true);
                setIsLoading(false);
            });
    }, [idsLongread, limit, offset, page]);

    return { data: resp, isLoading, error };
};

